import PropTypes from 'prop-types';
import * as React from 'react';
import Select from 'components/Select';
import EventTracking from 'lib/EventTracking';
import { Query } from 'react-apollo';
import { SubjectPicker as SubjectPickerQuery } from './queries/__generated__/SubjectPicker';
import SUBJECT_PICKER_QUERY from './queries/SubjectPickerQuery.gql';

import './styles/SubjectPicker.scss';

type Props = {
  initialSubject?: string;
  onChange: (subject?: string) => void;
};

type State = {
  selectedSubject?: string;
};

export class SubjectPicker extends React.Component<Props, State> {
  state: State = {
    selectedSubject: this.props.initialSubject,
  };

  static contextTypes = {
    eventScreenName: PropTypes.string,
  };

  setSubject = (subject: string) => {
    this.setState({ selectedSubject: subject });
    this.props.onChange(subject);
    EventTracking.tap(this.context.eventScreenName || 'subject_picker', 'save_subject', {
      subject,
    });
  };

  render() {
    return (
      <div className="SubjectPicker">
        <Query<SubjectPickerQuery> query={SUBJECT_PICKER_QUERY}>
          {({ loading, error, data }) => {
            if (loading || error) {
              return null;
            }

            if (data && data.settings && data.settings.class) {
              const subjects = data.settings.class.subjects.map((s: any) => ({
                value: s.subject_code,
                label: s.name,
              }));
              return (
                <Select
                  className="SubjectPicker-select"
                  options={subjects}
                  onChange={this.setSubject}
                  value={this.state.selectedSubject}
                  searchable
                />
              );
            } else {
              return null;
            }
          }}
        </Query>
      </div>
    );
  }
}

export default SubjectPicker;
